const FOLDER_TYPES = {
  MAIN_FOLDER: 1,
  NESTED_FOLDER: 2,
  RECORDS_FOLDER: 3
};

export default FOLDER_TYPES;
